import { locale, onChangeLocale } from '@signavio/i18n';
import { enUS } from 'date-fns/locale';
const availableLocales = {
  en_US: 'enUS',
  en_GB: 'enGB',
  de_DE: 'de',
  es_ES: 'es',
  fr_FR: 'fr',
  zh_CN: 'zhCN',
  ja_JP: 'ja',
  pt_BR: 'ptBR',
  it_IT: 'it',
  ko_KR: 'ko'
};
let dateFnsLocale;
const updateLocale = () => {
  const currentLocale = availableLocales[locale()] || availableLocales.en_US;
  void import(`date-fns/locale`).then(({
    [currentLocale]: currentLocaleDateFnsLocale
  }) => {
    if (!currentLocaleDateFnsLocale) {
      throw new Error(`Locale ${currentLocale} not found in date-fns locales`);
    }
    dateFnsLocale = currentLocaleDateFnsLocale;
  }).catch(error => {
    console.error(`Failed to load date-fns locale: ${error.message}`);
    dateFnsLocale = enUS;
  });
};
updateLocale();
onChangeLocale(updateLocale);
export const getDateFnsLocale = () => dateFnsLocale;